import React, { useContext, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';
import { BASE_URL_STATIC } from '../../../../../config';


const CnpCameraPopup = () => {

  const {
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    setShowCnpPhotoVideoPopup,
    setCnpPreviouslyOpenedPopup,
    handleCnpOpenPreviousPopup,

    showCnpCameraPopup, setShowCnpCameraPopup,
  } = useContext(ApiContext);


  const videoRef = useRef(null);

  const [isCameraStarted, setIsCameraStarted] = useState(false);
  const [capturedImage, setCapturedImage] = useState();
  

  // handle start camera
  const handleStartCamera = async () => {
    try {
      setIsCameraStarted(true);

      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      };
    } catch (err) {
      console.error('Error accessing camera:', err);

      setIsCameraStarted(false);
    };
  };

  // handle capture image
  const handleCaptureImage = () => {
    if (videoRef.current) {
      const canvas = document.createElement('canvas');
      const video = videoRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert the canvas content to a Blob
      canvas.toBlob(blob => {
        if (blob) {
          // Create a File object from the Blob
          const file = new File([blob], `${Date.now()}captured_image.jpeg`, { type: 'image/jpeg' });

          // console.log('capture : ', file);

          setCapturedImage(file);

          // Stop camera stream after capturing
          if (video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
            video.srcObject = null;
          };
        };
      }, 'image/jpeg');
    }
  };

  // handle add ✔️ capture image
  const handleAddCaptureImage = () => {
    if (!capturedImage) return;
  
    const newEntry = {
      file: capturedImage,
      tags: [],
    };
  
    const updatedEntries = [newEntry, ...cnpSelectedPhotoVideo];
  
    // Separate videos and images
    const videos = updatedEntries.filter(entry => entry.file.type.startsWith('video/'));
    // const images = updatedEntries.filter(entry => entry.file.type.startsWith('image/'));
  
    // Enforce limits
    if (videos.length > 5) {
      alert("You can select maximum 5 videos.");
      return;
    }
  
    if (updatedEntries.length > 15) {
      alert("You can select maximum 15 files in total (videos + images).");
      return;
    }
  
    setCnpSelectedPhotoVideo(updatedEntries);
  
    setIsCameraStarted(false);
    setCapturedImage();
    setShowCnpCameraPopup(false);
    setShowCnpPhotoVideoPopup(true);
    setCnpPreviouslyOpenedPopup('photoVideo');
  };  
  
  // handle cancel ❌ capture image
  const handleCancelCaptureImage = () => {
    setCapturedImage();

    handleStartCamera();
  };


  // handle close camera popup
  const handleCloseCameraPopup = () => {
    setShowCnpCameraPopup(false);

    handleCnpOpenPreviousPopup();
  };


  return (
    <>
      <Modal show={showCnpCameraPopup} onHide={handleCloseCameraPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseCameraPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3 mb-0'>Camera</h5>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          {/* Step 1 - Start    */}
          {/* Step 2 - Capture  */}
          {/* Step 3 - ✔️/❌   */}

          <>
            {
              isCameraStarted
              ?
              // Step 2 & 3
              <>
                {
                  capturedImage
                  ?
                  // Step 3
                  <>
                    <img src={URL.createObjectURL(capturedImage)} alt="capturedImage" />

                    <div className='d-flex align-items-center justify-content-evenly mt-3'>
                      <span className='cursor-pointer' role="img" aria-label="confirm" onClick={handleAddCaptureImage}>✔️</span>

                      <span className='cursor-pointer' role="img" aria-label="cancel" onClick={handleCancelCaptureImage}>❌</span>
                    </div>
                  </>
                  :
                  // Step 2
                  <>
                    <video className='my-3' ref={videoRef} autoPlay playsInline />

                    <div className='text-center'>
                      <button className='btn btn-primary btn-sm my-3' onClick={handleCaptureImage}>Capture</button>
                    </div>
                  </>
                }
              </>
              :
              // Step 1
              <>
                <img src={`${BASE_URL_STATIC}/camera-bg.png`} alt="start" />                

                <div className='text-center'>
                  <button className='btn btn-primary btn-sm my-3' onClick={handleStartCamera}>Start</button>
                </div>
              </>
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CnpCameraPopup